import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import updateCommunityService from '../../services/community/updateCommunityService';
import CommunityFormModal from './CommunityFormModal';

const EditCommunity = ({ open, dispatchUpdateCommunityPut, updateCommunityFetch }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const communityFetch = useSelector(state => state?.repository?.community || {});

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateCommunityPut(
        id,
        body,
        () => navigate(`/communities/edit/${id}/details`),
        t
      ),
    [id, dispatchUpdateCommunityPut, t, navigate]
  );

  if (!open) return null;

  return (
    <CommunityFormModal
      editMode
      header={communityFetch.value?.name}
      onSubmit={handleSubmit}
      submitProcessing={updateCommunityFetch.pending}
      returnRoute={`/communities/edit/${id}/details`}
      cancelRoute={`/communities/edit/${id}/details`}
      dataLoading={communityFetch.pending}
      data={!communityFetch.pending && communityFetch.value}
    />
  );
};

EditCommunity.propTypes = {
  dispatchUpdateCommunityPut: PropTypes.func.isRequired,
  updateCommunityFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditCommunity.defaultProps = { open: false };

export default updateCommunityService(EditCommunity);
